import { Injectable } from "@angular/core";

import * as firebase from "firebase";

import { Song } from "../../models/Song";
import { Artist } from "../../models/Artist";
import { Album } from "../../models/Albums";
import { FirebaseStorageService } from "../FirebaseStorage/firebase-storage.service";
import { Playlist } from "../../models/Playlist";
import { Genre } from "../../models/Genre";
import { GenreHelper } from "../../models/GenreHelper";
import { PlaylistGroup } from "../../models/PlaylistGroup";
import { Users } from "src/app/models/users";
import { Mood } from "src/app/models/Mood";
import { SongDetails } from '../../models/songDetails';
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class FirestoreService {
  constructor(private firebaseStorage: FirebaseStorageService) { }

  initialiseGenres() {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      GenreHelper.genres.forEach(genre => {
        db.collection("genres")
          .add({
            name: genre.name
          })
          .then(function (ref) {
            resolve(ref);
          })
          .catch(function (error) {
            reject(error);
          });

        // resolve();
      });
    });

    return promise;
  }

  getUsers() {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("users")
        .get()
        .then(usersSnapshot => {
          const users = [];

          usersSnapshot.forEach(doc => {
            // console.log('doc', doc.data(), doc.id);
            const user = new Users(doc.id, doc.data().name, doc.data().email);
            // user.userId = doc.id;
            // user.emailId = doc.data().email;
            users.push(user);
          });

          resolve({ users: users });
        });
    });

    return promise;
  }




  getGenres() {
    const promise = new Promise((resolve) => {
      const db = firebase.firestore();

      db.collection("genres")
        .get()
        .then(genresSnapshot => {
          const genres = [];

          genresSnapshot.forEach(doc => {
            const genre = new Genre(doc.data().name, doc.data().picture);
            genre.genreId = doc.id;

            genres.push(genre);
          });

          resolve({ genres: genres });
        });
    });

    return promise;
  }

  getSongs() {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("songs")
        .get()
        .then(songsSnapshot => {
          const songs = [];

          songsSnapshot.forEach(doc => {
            const song = new Song();

            song.songId = doc.id;
            song.name = doc.data().name;
            song.artistId = doc.data().artistId;
            song.artistName = doc.data().artistName;
            song.albumId = doc.data().albumId;
            song.albumName = doc.data().albumName;
            song.albumPicture = doc.data().albumPicture;
            song.songUrl = doc.data().songUrl;

            songs.push(song);
          });

          resolve({ songs: songs });
        });
    });

    return promise;
  }

  getAlbumSongs(albumId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("songs")
        .where("albumId", "==", albumId)
        .get()
        .then(songsSnapshot => {
          const songs = [];

          songsSnapshot.forEach(doc => {
            const song = new Song();

            song.songId = doc.id;
            song.name = doc.data().name;
            song.artistId = doc.data().artistId;
            song.artistName = doc.data().artistName;
            song.albumId = doc.data().albumId;
            song.albumName = doc.data().albumName;
            song.albumPicture = doc.data().albumPicture;
            song.songUrl = doc.data().songUrl;

            songs.push(song);
          });

          resolve({ songs: songs });
        });
    });

    return promise;
  }

  getArtists() {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("artists")
        .get()
        .then(artistsSnapshot => {
          const artists = [];

          artistsSnapshot.forEach(doc => {
            const artist = new Artist();

            artist.artistId = doc.id;
            artist.name = doc.data().name;
            artist.picture = doc.data().picture;

            artists.push(artist);
          });

          resolve({ artists: artists });
        });
    });

    return promise;
  }

  getAlbums() {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("albums")
        .get()
        .then(albumsSnapshot => {
          const albums = [];

          albumsSnapshot.forEach(doc => {
            const album = new Album();

            album.albumId = doc.id;
            album.name = doc.data().name;
            album.picture = doc.data().picture;
            album.artistId = doc.data().artistId;
            album.artistName = doc.data().artistName;

            albums.push(album);
          });

          resolve({ albums: albums });
        });
    });

    return promise;
  }

  getArtistAlbums(artistId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("albums")
        .where("artistId", "==", artistId)
        .get()
        .then(albumsSnapshot => {
          const albums = [];

          albumsSnapshot.forEach(doc => {
            const album = new Album();

            album.albumId = doc.id;
            album.name = doc.data().name;
            album.picture = doc.data().picture;
            album.artistId = doc.data().artistId;
            album.artistName = doc.data().artistName;

            albums.push(album);
          });

          resolve({ albums: albums });
        });
    });

    return promise;
  }


  addNewMood(newMood: Mood) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("genres")
        .add({
          name: newMood.name,
          picture: newMood.picture
        })
        .then(function (ref) {
          resolve({ newMoodId: ref.id });
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  editMoodName(moodId: string, moodName: string) {
    console.log({ moodId, moodName });
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("genres")
        .doc(moodId)
        .set(
          {
            name: moodName
          },
          { merge: true }
        )
        .then(function (s) {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  editMoodPicture(moodId: string, moodPicture: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("genres")
        .doc(moodId)
        .set(
          {
            picture: moodPicture
          },
          { merge: true }
        )
        .then(function (s) {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }




  addNewArtist(newArtist: Artist) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("artists")
        .add({
          name: newArtist.name,
          picture: newArtist.picture
        })
        .then(function (ref) {
          resolve({ newArtistId: ref.id });
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  deleteArtist(artist: Artist) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("artists")
        .doc(artist.artistId)
        .delete()
        .then(() => {
          // Delete artist picture
          const deletePath = `/${artist.name}/artistPicture`;
          this.firebaseStorage.deleteFile(deletePath);

          // Delete all artist's albums
          this.getArtistAlbums(artist.artistId).then((result: any) => {
            result.albums.forEach(album => {
              this.deleteAlbum(album);
            });

            resolve(true);
          });
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  editArtistName(artistId: string, artistName: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("artists")
        .doc(artistId)
        .set(
          {
            name: artistName
          },
          { merge: true }
        )
        .then(function () {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  editArtistPicture(artistId: string, artistPicture: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("artists")
        .doc(artistId)
        .set(
          {
            picture: artistPicture
          },
          { merge: true }
        )
        .then(function () {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  addNewAlbum(newAlbum: Album) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("albums")
        .add({
          name: newAlbum.name,
          picture: newAlbum.picture,
          artistId: newAlbum.artistId,
          artistName: newAlbum.artistName
        })
        .then(function (ref) {
          resolve({ newAlbumId: ref.id });
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  deleteAlbum(album: Album) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("albums")
        .doc(album.albumId)
        .delete()
        .then(() => {
          // Delete album picture
          const deletePath = `/${album.artistName}/${album.name}/albumPicture`;
          this.firebaseStorage.deleteFile(deletePath);

          // Delete all artist's albums
          this.getAlbumSongs(album.albumId).then((result: any) => {
            result.songs.forEach(song => {
              this.deleteSong(song);
            });

            resolve(true);
          });
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  editAlbumName(albumId: string, albumName: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("albums")
        .doc(albumId)
        .set(
          {
            name: albumName
          },
          { merge: true }
        )
        .then(function () {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  editAlbumPicture(albumId: string, albumPicture: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("albums")
        .doc(albumId)
        .set(
          {
            picture: albumPicture
          },
          { merge: true }
        )
        .then(function () {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  addNewSong(newSong: Song) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("songs")
        .add({
          name: newSong.name,
          artistId: newSong.artistId,
          artistName: newSong.artistName,
          albumId: newSong.albumId,
          albumName: newSong.albumName,
          albumPicture: newSong.albumPicture,
          songUrl: newSong.songUrl,
          moodId: "",
          moodName: ""
        })
        .then(function (ref) {
          resolve({ newSongId: ref.id });
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  editSongName(songId: string, songName: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("songs")
        .doc(songId)
        .set(
          {
            name: songName
          },
          { merge: true }
        )
        .then(function () {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  editSong(songId: string, songUrl: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("songs")
        .doc(songId)
        .set(
          {
            songUrl: songUrl
          },
          { merge: true }
        )
        .then(function () {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  deleteSong(song: Song) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("songs")
        .doc(song.songId)
        .delete()
        .then(() => {
          const deletePath = `/${song.artistName}/${song.albumName}/${song.name
            }`;

          this.firebaseStorage.deleteFile(deletePath);
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  getPlaylists() {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("playlists")
        .orderBy("addedAt", "desc")
        .get()
        .then(playlistsSnapshot => {
          const playlists = [];

          playlistsSnapshot.forEach(doc => {
            const playlist = new Playlist();

            playlist.playlistId = doc.id;
            playlist.name = doc.data().name;
            playlist.picture = doc.data().picture;

            playlists.push(playlist);
          });

          resolve({ playlists: playlists });
        });
    });

    return promise;
  }

  addNewPlaylist(newPlaylist: Playlist) {
    console.log('playlist', newPlaylist);
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("playlists")
        .add({
          name: newPlaylist.name,
          picture: newPlaylist.picture,
          addedAt: firebase.firestore.FieldValue.serverTimestamp()
        })
        .then(function (ref) {
          console.log('ref', ref);
          resolve({ newPlaylistId: ref.id });
        })
        .catch(function (error) {
          console.log('err', error);
          reject(error);
        });
    });

    return promise;
  }

  editPlaylistName(playlistId: string, playlistName: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("playlists")
        .doc(playlistId)
        .set(
          {
            name: playlistName
          },
          { merge: true }
        )
        .then(function () {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  editPlaylistPicture(playlistId: string, playlistPicture: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("playlists")
        .doc(playlistId)
        .set(
          {
            picture: playlistPicture
          },
          { merge: true }
        )
        .then(function () {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  deletePlaylist(playlist: Playlist) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("playlists")
        .doc(playlist.playlistId)
        .delete()
        .then(() => {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  getPlaylistSongs(playlist: Playlist) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("playlists")
        .doc(playlist.playlistId)
        .collection("songs")
        .get()
        .then(playlistSongsSnapshot => {
          const playlistSongs = [];

          playlistSongsSnapshot.forEach(doc => {
            const song = new Song();

            song.playlistSongId = doc.id;
            song.songId = doc.data().songId;
            song.name = doc.data().name;
            song.artistId = doc.data().artistId;
            song.artistName = doc.data().artistName;
            song.albumId = doc.data().albumId;
            song.albumName = doc.data().albumName;
            song.albumPicture = doc.data().albumPicture;
            song.songUrl = doc.data().songUrl;

            playlistSongs.push(song);
          });

          resolve({ playlistSongs: playlistSongs });
        });
    });

    return promise;
  }

  addSongToPlaylist(song: Song, playlist: Playlist) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("playlists")
        .doc(playlist.playlistId)
        .collection("songs")
        .add({
          songId: song.songId,
          name: song.name,
          artistId: song.artistId,
          artistName: song.artistName,
          albumId: song.albumId,
          albumName: song.albumName,
          albumPicture: song.albumPicture,
          songUrl: song.songUrl
        })
        .then(function (ref) {
          resolve({ newPlaylistSongId: ref.id });
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  removeSongFromPlaylist(song: Song, playlist: Playlist) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("playlists")
        .doc(playlist.playlistId)
        .collection("songs")
        .doc(song.playlistSongId)
        .delete()
        .then(function (ref) {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  getArtistsCount() {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("artists")
        .get()
        .then(artistsSnapshot => {
          resolve({ count: artistsSnapshot.size });
        });
    });

    return promise;
  }

  getAlbumsCount() {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("albums")
        .get()
        .then(albumsSnapshot => {
          resolve({ count: albumsSnapshot.size });
        });
    });

    return promise;
  }

  getSongsCount() {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("songs")
        .get()
        .then(songsSnapshot => {
          resolve({ count: songsSnapshot.size });
        });
    });

    return promise;
  }

  getPlaylistsCount() {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("playlists")
        .get()
        .then(playlistsSnapshot => {
          resolve({ count: playlistsSnapshot.size });
        });
    });

    return promise;
  }

  updateSongMood(song: Song, genre: Genre) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("songs")
        .doc(song.songId)
        .set({
          moodName: genre.name,
          moodId: genre.genreId
        }, {
          merge: true
        })
        .then(function (ref) {
          console.log('update song mood', ref);
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  addSongToGenre(song: Song, genre: Genre) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("genres")
        .doc(genre.genreId)
        .collection("songs")
        .add({
          songId: song.songId,
          name: song.name,
          artistId: song.artistId,
          artistName: song.artistName,
          albumId: song.albumId,
          albumName: song.albumName,
          albumPicture: song.albumPicture,
          songUrl: song.songUrl
        })
        .then((ref) => {
          console.log('ref', ref.id);
          this.updateSongMood(song, genre);
          resolve({ newGenreSongId: ref.id });
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }



  removeSongFromGenre(song: Song, genre: Genre) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("genres")
        .doc(genre.genreId)
        .collection("songs")
        .doc(song.genreSongId)
        .delete()
        .then((ref) => {
          const db = firebase.firestore();

          db.collection("songs")
            .doc(song.songId)
            .set({
              moodName: "",
              moodId: ""
            }, {
              merge: true
            })
            .then(function (ref) {
              console.log('remove song mood', ref);
              resolve(true);
            })
            .catch(function (error) {
              reject(error);
            });
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  getGenreSongs(genre: Genre) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("genres")
        .doc(genre.genreId)
        .collection("songs")
        .get()
        .then(genreSongsSnapshot => {
          const genreSongs = [];

          genreSongsSnapshot.forEach(doc => {
            const song = new Song();

            song.genreSongId = doc.id;
            song.songId = doc.data().songId;
            song.name = doc.data().name;
            song.artistId = doc.data().artistId;
            song.artistName = doc.data().artistName;
            song.albumId = doc.data().albumId;
            song.albumName = doc.data().albumName;
            song.albumPicture = doc.data().albumPicture;
            song.songUrl = doc.data().songUrl;

            genreSongs.push(song);
          });

          resolve({ genreSongs: genreSongs });
        });
    });

    return promise;
  }

  getPlaylistGroups() {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("playlistGroups")
        .orderBy("addedAt", "desc")
        .get()
        .then(playlistGroupsSnapshot => {
          const playlistGroups = [];

          playlistGroupsSnapshot.forEach(doc => {
            const playlistGroup = new PlaylistGroup();

            playlistGroup.playlistGroupId = doc.id;
            playlistGroup.name = doc.data().name;

            playlistGroups.push(playlistGroup);
          });

          resolve({ playlistGroups: playlistGroups });
        });
    });

    return promise;
  }

  addNewPlaylistGroup(newPlaylistGroup: PlaylistGroup) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("playlistGroups")
        .add({
          name: newPlaylistGroup.name,
          addedAt: firebase.firestore.FieldValue.serverTimestamp()
        })
        .then(function (ref) {
          resolve({ newPlaylistGroupId: ref.id });
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  editPlaylistGroupName(playlistGroupId: string, playlistGroupName: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("playlistGroups")
        .doc(playlistGroupId)
        .set(
          {
            name: playlistGroupName
          },
          { merge: true }
        )
        .then(function () {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  deletePlaylistGroup(playlistGroup: PlaylistGroup) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("playlistGroups")
        .doc(playlistGroup.playlistGroupId)
        .delete()
        .then(() => {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  getPlaylistGroupPlaylists(playlistGroup: PlaylistGroup) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("playlistGroups")
        .doc(playlistGroup.playlistGroupId)
        .collection("playlists")
        .orderBy("addedAt", "asc")
        .get()
        .then(playlistGroupPlaylistsSnapshot => {
          const playlistGroupPlaylists = [];

          playlistGroupPlaylistsSnapshot.forEach(doc => {
            const playlist = new Playlist();

            playlist.playlistGroupPlaylistId = doc.id;
            playlist.playlistId = doc.data().playlistId;
            playlist.name = doc.data().name;
            playlist.picture = doc.data().picture;

            playlistGroupPlaylists.push(playlist);
          });

          resolve({ playlistGroupPlaylists: playlistGroupPlaylists });
        });
    });

    return promise;
  }

  getSongDetails(startDate?: any, endDate?: any, songId?: any) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      var Startdate = (startDate) ? new Date(startDate) : new Date();
      var endBefore = (endDate) ? new Date(endDate) : new Date();

      db.collection("songDetail")
        .where("songId", "==", songId)
        .orderBy("date").startAfter(Startdate).endBefore(endBefore)

        .get()
        .then(SongDetailSnapshot => {
          const SongDetailSnapshotPlaylists = [];
          console.clear();
          console.log({ Startdate, endBefore })

          SongDetailSnapshot.forEach(doc => {

            const songDetails = new SongDetails();

            songDetails.songId = doc.data().songId;
            songDetails.name = doc.data().name;
            songDetails.moodId = doc.data().moodId;
            songDetails.moodName = doc.data().moodName;
            songDetails.date = doc.data().date;
            songDetails.numberOfPlayed = doc.data().numberOfPlayed;
            songDetails.totalTime = doc.data().totalTime;
            songDetails.userId = doc.data().userId;

            // console.log(doc.data())
            SongDetailSnapshotPlaylists.push(doc.data());
            // }
          });

          resolve({ SongDetailSnapshotPlaylists: SongDetailSnapshotPlaylists });
        });
    });

    return promise;
  }

  addPlaylistToPlaylistGroup(playlist: Playlist, playlistGroup: PlaylistGroup) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("playlistGroups")
        .doc(playlistGroup.playlistGroupId)
        .collection("playlists")
        .add({
          playlistId: playlist.playlistId,
          name: playlist.name,
          picture: playlist.picture,
          addedAt: firebase.firestore.FieldValue.serverTimestamp()
        })
        .then(function (ref) {
          resolve({ newPlaylistGroupPlaylistId: ref.id });
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  removePlaylistFromPlaylistGroup(playlist: Playlist, playlistGroup: PlaylistGroup) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("playlistGroups")
        .doc(playlistGroup.playlistGroupId)
        .collection("playlists")
        .doc(playlist.playlistGroupPlaylistId)
        .delete()
        .then(function (ref) {
          // resolve();
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }
  getPrivacy() {
    var observable = new Observable((observer) => {
      const db = firebase.firestore();
      db.collection('privacy')
        .doc("QlLQFVvF3ZKK1nF3K7B4")
        .get()
        .then(ref => {
          console.log('data', ref.data());
          observer.next(ref.data());
        }).catch((e) => {
          console.log({ e });
          observer.next(e);
        })
    });
    return observable;
  }

  updatePrivacy(privacyContent: string) {
    var observable = new Observable((observer) => {
      const db = firebase.firestore();
      db.collection('privacy')
        .doc("QlLQFVvF3ZKK1nF3K7B4")
        .update({
          htmlContent: privacyContent
        })
        .then((ref) => {
          console.log('data', ref);
          observer.next(true);
        }).catch((e) => {
          console.log({ e });
          observer.next(false);
        })
    });
    return observable;
  }
  getTerms() {
    var observable = new Observable((observer) => {
      const db = firebase.firestore();
      db.collection('terms')
        .doc("bznza2rriADzzoHLRp1O")
        .get()
        .then(ref => {
          console.log('data', ref.data());
          observer.next(ref.data());
        }).catch((e) => {
          console.log({ e });
          observer.next(e);
        })
    });
    return observable;
  }

  updateTerms(terms: string) {
    var observable = new Observable((observer) => {
      const db = firebase.firestore();
      db.collection('terms')
        .doc("bznza2rriADzzoHLRp1O")
        .update({
          htmlContent: terms
        })
        .then((ref) => {
          observer.next(true);
        }).catch((e) => {
          console.log({ e });
          observer.next(false);
        })
    });
    return observable;
  }
}
